<template>
    <div class="row">
        <div class="form-inline col-md-2">
            <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon color="grey lighten-1" class="tooltip-small">
                            mdi-information-outline
                        </v-icon>
                    </v-btn>
                </template>
                <span>Enter the competitors distance radius and select measuring unit.</span>
            </v-tooltip>
            <i class="fas fa-ruler-horizontal"></i> <span style="padding-left: 5px;"> Distance</span>
        </div>
        <div class="form-group col-md-2">
            <v-text-field
                label="Distance"
                v-model="distance"
                :rules="[requiredDistance]"
            ></v-text-field>
        </div><!--form-group-->
        <div class="form-group col-md-2">
            <v-select
                label="Unit"
                v-model="unit"
                :items="distance_units"
                @change="unitChanged()"
            ></v-select>
        </div><!--form-group-->
    </div>
</template>

<script>
export default {
    name: "Distance",
    props: [
        'dataSetOrder',
        'analysisType'
    ],
    data: () => ({
        distance_units: ['miles', 'meters'],

        requiredDistance: v => v && v > 0 || 'Distance field is required',
    }),
    methods: {
        unitChanged() {
            if (this.$store.getters['CreateAudienceStore/getLimitsDistanceUnit'](this.dataSetOrder) === 'meters') {
                this.$store.getters['CreateAudienceStore/getLimitsDistance'](this.dataSetOrder)

                this.$store.commit('CreateAudienceStore/SET_LIMITS_DISTANCE', {
                    dataset: this.dataSetOrder,
                    value: (this.$store.getters['CreateAudienceStore/getLimitsDistance'](this.dataSetOrder) * this.total_meters_in_one_mile).toFixed(3)
                })

            } else if (this.unit === 'miles') {
                this.$store.commit('CreateAudienceStore/SET_LIMITS_DISTANCE', {
                    dataset: this.dataSetOrder,
                    value: (this.$store.getters['CreateAudienceStore/getLimitsDistance'](this.dataSetOrder) / this.total_meters_in_one_mile).toFixed(3)
                })
            }
        },
    },
    mounted() {
        //
    },
    computed: {
        distance: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLimitsDistance'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_LIMITS_DISTANCE', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        },
        unit: {
            get() {
                return this.$store.getters['CreateAudienceStore/getLimitsDistanceUnit'](this.dataSetOrder)
            },
            set(value) {
                this.$store.commit('CreateAudienceStore/SET_LIMITS_DISTANCE_UNIT', {
                    dataset: this.dataSetOrder,
                    value: value
                })
            }
        }
    },
    watch: {
        //
    }
}
</script>

<style scoped>

</style>